import { useQuery } from '@tanstack/react-query';

import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplicationLixiXml } from '../../requests/getApplicationLixiXml';

export const useApplicationLixiXml = (
  uuid: string,
  definitionName: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplicationLixiXml>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, 'lixi-xml'],
    queryFn: () => getApplicationLixiXml(constructGet, uuid, definitionName),
    enabled: Boolean(uuid) && (options?.enabled ?? false),
    onError: () => handleError('Could not load Lixi XML for application.'),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'lixiXml'),
    ...rest,
  };
};
